import { expandGroupsAndSmallDLs } from '../actions/publicActions';
import { RecipientExpansionStatus } from 'owa-recipient-types/lib/types/RecipientExpansionStatus';
import { RecipientMemberInfo } from 'owa-recipient-types/lib/types/RecipientMemberInfo';
import { SharingTipRecipientInfo, lazyGetGroupsAndSmallDLs } from 'owa-sharing-data';

export async function tryGetGroupAndSmallDLRecipients(
    linkIds: string[],
    recipientInfos: SharingTipRecipientInfo[],
    composeId: string
): Promise<[boolean, RecipientMemberInfo[]]> {
    const getGroupsAndSmallDLs = await lazyGetGroupsAndSmallDLs.import();
    const smallDLsAndGroups = getGroupsAndSmallDLs(recipientInfos);
    const allRecipients: RecipientMemberInfo[] = [];
    const shouldExpand: boolean = smallDLsAndGroups.some(
        info => info.recipient.expansionStatus === RecipientExpansionStatus.None
    );

    if (shouldExpand) {
        expandGroupsAndSmallDLs(linkIds, smallDLsAndGroups, composeId);
        return [false, allRecipients];
    }
    const successfullyExpandedSmallDLs: SharingTipRecipientInfo[] = smallDLsAndGroups.filter(
        smallDL =>
            smallDL.recipient.expansionStatus ===
            RecipientExpansionStatus.SucceededWithoutDLOrGroupMembers
    );
    if (successfullyExpandedSmallDLs.length !== smallDLsAndGroups.length) {
        return [false, allRecipients];
    }

    successfullyExpandedSmallDLs.forEach(function (expandedSmallDL) {
        expandedSmallDL.recipient.members.forEach(function (member) {
            allRecipients.push(member);
        });
    });

    return [true, allRecipients];
}
